import { Component, OnInit, ErrorHandler } from '@angular/core';
import { RegistrationService } from '../../registration.service';

import { FormGroup, FormControl, NgForm } from '@angular/forms';
import { forEach } from '@angular/router/src/utils/collection';
import swal from 'sweetalert2';
import { HandleError } from '../../shared/HandleError';
declare var $: any;

@Component({
  selector: 'app-basic-registration',
  templateUrl: './basic-registration.component.html',
  styleUrls: ['./basic-registration.component.css']
})
export class BasicRegistrationComponent implements OnInit {
  OAVillages: any;
  OATaluks: any;
  OADistricts: any;
  PADistricts: any;
  PAVillages: any;
  PATaluks: any;
  Villages: any;
  Taluks: any;
  Districts: any;
  States: any=null;
  SainikDetails: any;
  s: any = {};
  EquivalentTypes: any;
  ServiceCategories: any;
  fileToUpload: File = null;
  formInvalid: boolean = false;
  OccupationTypes: any;
  Relations: any;
  Castes: any;
  Relegions: any;
  ServiceTypes: any;
  CivilTypes: any;
  Qualifications: any;
  Corps: any;
  Ranks: any;
  data: any;
  title = "Basic Registration";
  //c:any;
  Ranklist = [
    "Marshal of Air Force",
    "Air Chief Marshal",
    "Air Marshal",
    "Air Vice Marshal",
    "Air Commodore",
    "Group Captain",
    "Wing Commander",
    "Squadron leader",
    "Flight lieutenant",
    "Flying Officer",
    "Pilot Officer",
    "Master Warrant officer / Hon Flt Lt",
    "Warrant Officer",
    "Junior Warrant officer",
    "Sergeant",
    "Corporal",
    "Leading Aircraftsman",
    "Airman",
    "Other",
  ];
  fingerprintimageUrl: string = "assets/images/image-default.png";
  mode: string = "save";

  options = [
    { id: 1, name: 'One' },
    { id: 2, name: 'Two' },
    { id: 3, name: 'Three' },
  ];
  filteredOptions = this.States;
  UserName: string;
  RoleName: string;
  finalizeddata: any;
  idCardNumbers:any = [];
  regiments:any;
  Formdiable: boolean = false;
  Ranklevels: any;
  rankobj: any= [];

  fd: any = {};
  SD_Gender_errormessage: string;
  SD_Qualifictaion_errormessage: string;
  Stations: any;
  recordofficedetails: any=[];
  dependentsview: any={};
  SRMobileNo_errormessage: any;
  // q: any = {};

  speedSearchFilter(val: string) {
    this.filteredOptions = this.States.filter(state => state.name.toLowerCase().indexOf(val.toLowerCase()) === 0)
  }
  // private handleError:HandleError
  constructor(private service: RegistrationService,private handleError:HandleError) {
  }

  ngOnInit() {
    
    this.GetAllRanks();
    this.GetAllCorps();
    this.GetAllQualifications();
    this.GetAllCivilTypes();
    this.GetAllEquivalentTypes();
    this.GetAllServiceTypes();
    this.GetAllServiceCategories();
    this.GetAllRelegions();
    this.GetAllCaste();
    this.GetAllRelations();
    this.GetAllOccupationTypes();
    this.GetStates();
    this.GetIdCardNumbers();
    this.GetRegiments();
    this.GetAllStationsOfRecordOfficeAddress();
    this.UserName=localStorage.getItem('userName');
    this.RoleName=localStorage.getItem('userRole');
    if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
    this.s.SR_ServiceNo=this.UserName;
    // this.GetSainikBasicDetails(this.s.SR_ServiceNo)
    this.GetSainikDetailsFromRegistration(this.s.SR_ServiceNo);
    this.Getfinalize(this.s.SR_ServiceNo);    
    }    
  }
  GetIdCardNumbers()
  {
    
    this.data = this.service.getIdCardNumbers();
    this.data.subscribe(
      (response) => {
        this.idCardNumbers=response;
        console.log(this.idCardNumbers);
      },
      (error) => {
        //console.log(error);
      });
  }
  GetRegiments()
  {
    
    this.data = this.service.getRegiments();
    this.data.subscribe(
      (response) => {
        this.regiments=response;
      },
      (error) => {
        //console.log(error);
      });
  }
 /* keyPress(event: any) {    
    const pattern =/[A-Za-z]/;
    let inputChar = String.fromCharCode(event.charCode);
    var uname = new String(event.target.value)
    if (!pattern.test(inputChar) && uname.trim().length==0)
    {
      event.preventDefault();
    }
 }
 keyPressNumbersOnly(event: any) {
  const pattern = /[0-9]/;
  let inputChar = String.fromCharCode(event.charCode);
  // console.log(inputChar, e.charCode);
     if (!pattern.test(inputChar)) {
     // invalid character, prevent input
         event.preventDefault();
    }
}*/
/*keyPressHouseNumber(event: any) {
  const pattern =/^[a-zA-Z0-9.#/]+$/;
  let inputChar = String.fromCharCode(event.charCode);
  var uname = new String(event.target.value)
  if (!pattern.test(inputChar))
  {
    event.preventDefault();
  }
} */

  Getfinalize(SR_ServiceNo)
  {
    
    this.data = this.service.getfinalize(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.finalizeddata=response;
        if(this.finalizeddata=='F')
       {
        this.Formdiable=true;
       }
      },
      (error) => {
        //console.log(error);
      });
  }
  
  GetSainikDetailsFromRegistration(serviceNo) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getSainikDetailsFromRegistration(serviceNo);
    this.data.subscribe(
      (response) => {
        
        this.s.SR_HonoraryRank='YS'
        this.s.SR_Veteran='YS'
        this.s.SR_Alive='YS'
        if (response != null) {
          this.s = response;
          if (this.s.SR_DOB != null)
            this.s.SR_DOB = ((this.s.SR_DOB).split('T'))[0];
          if (this.s.SR_DOC != null)
            this.s.SR_DOC = ((this.s.SR_DOC).split('T'))[0];
          if (this.s.SR_EnrollmentDate != null)
            this.s.SR_EnrollmentDate = ((this.s.SR_EnrollmentDate).split('T'))[0];
          if (this.s.SR_DOD != null)
            this.s.SR_DOD = ((this.s.SR_DOD).split('T'))[0];
          if (this.s.SR_DischargeDate != null)
            this.s.SR_DischargeDate = ((this.s.SR_DischargeDate).split('T'))[0];
          this.s.SR_ServiceType = this.s.ServiceTypes.SER_Id;
          this.s.SR_Category = this.s.ServiceCategories.CA_Id;
          this.s.SR_Rank = this.s.Ranks.Rank_Id;
          
          this.GetAllRankLevels(this.s.ServiceTypes.SER_Id,this.s.Ranks.Rank_Id);
          this.s.SR_RankLevel = this.s.SR_RankLevel;//For RankLevel
         //this.s.SR_RankLevel=this.s.RankLevels.RL_Id;
          this.s.SR_Qualification = this.s.Qualifications.Q_Id;
          //this.s.SR_Corps = this.s.Corps.Corps_Id;
           //this.s.SR_CivilType = this.s.CivilTypes.Civil_Type_Id;
           this.s.SR_CivilType = this.s.SR_CivilType;
          this.s.SR_EquivalentType = this.s.EquivalentTypes.Equivalent_Type_Id;
          this.s.SR_Relegion = this.s.Relegions.Relegion_Id;
          this.s.SR_Caste = this.s.SR_Caste;   
          this.s.SR_OccupationType = this.s.OccupationTypes.OCT_Id;
          if(this.s.SR_OA_Pincode==0)
          this.s.SR_OA_Pincode=null;
          // this.GetStates();
         //D this.s.SR_OA_State = response.SR_OA_State;
          //this.s.SR_OA_District = response.SR_OA_District;
         // this.s.SR_State = response.SR_State
         // this.s.SR_District=this.s.Districts.DI_Id;
         if (this.s.SR_ServiceNo!=null &&  this.s.SR_ServiceType!=""||  this.s.SR_ServiceType==undefined || this.s.SR_ServiceType==null){
           
          this.mode = "update";
          }
        else {
          
          this.mode = "save";         
              }
         
          this.mode = "update";
          this.GetStates();          
         //this.GetAllRankLevels(response.ServiceTypes.SER_Id,response.SR_RankLevel);
          this.GetOADistricts(response.SR_OA_State);
          this.GetDistricts(response.SR_State);
          this.GetPADistricts(response.SR_PA_State);
          //this.GetTaluks(response.SR_District);
          //this.GetPATaluks(response.SR_PA_District);
          //this.GetVillages(response.SR_Mandal);
          //this.GetPAVillages(response.SR_PA_Mandal);
          //this.GetPincode(response.SR_Village);
         // this.GetPAPincode(response.SR_PA_Village);
          this.fingerprintimageUrl=response.SR_FingerPrint;
          this.s.SR_FingerPrint=response.SR_FingerPrint;
          this.s.FingerPrintImagePath=response.FingerPrintImagePath;
          if(response.SR_Pincode==0)
          this.s.SR_Pincode=null;
         // document.getElementById('SR_FingerPrint').nodeValue=response.SR_Id+'.jpeg';
          
        }


        //Dependents details
        if (response.SainikDependents.length != 0) {
          this.mode = "update";
          this.dependentsview="viewdependent";
        this.fd = {};
        this.fd = response.SainikDependents[0];
        this.fd.j=0;
        this.fd.relationid = this.GetRelationId(this.fd.Relations.Relation_Name);
        this.fd.qualificationid = this.GetQualifactionId(this.fd.SD_Qualification)
        this.fd['SD_DOB'] = ((response.SainikDependents[0].SD_DOB).split('T'))[0];
      }

      if(response.SR_Alive=='Yes')
      {
        this.s.SR_Alive='YS'
      }

        //  this.s.SR_ServiceType=response.sainikRegistrationBasicDetails.ServiceTypes.SR_ServiceType;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
         if (error.status == 400)       
       swal('Warning!', 'Please fill all the Details.', 'warning');
        
        // else if(error.status == 401)
        // swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }


  // reloadPage(){
  //   window.location.reload();
  // }


  //Image
  FingerPrintFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.s.SR_FingerPrint="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.fingerprintimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.service.uploadImage(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('SR_FingerPrint');
          i.value="";
          if (error.status == 400) {
            this.fingerprintimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('SR_FingerPrint');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }
  CanAddFamily(form){

  }

  getFingerPrintImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('SR_FingerPrint');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  //Save
  SaveBasicRegistration(br: NgForm) {    
    
   // alert(this.s.SR_PA_Pincode.getRawValue());
     if (br.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      br.value.SR_FingerPrint = this.getFingerPrintImage();
      br.value.SR_Pincode=this.s.SR_Pincode;
      br.value.SR_PA_Pincode=this.s.SR_PA_Pincode;
      br.value.IdCardCode = this.s.IdCardCode;
      br.value.SainikDependents = this.FamilyDetails;
      this.data = this.service.saveSainikBasicRegistration(br.value);
      this.data.subscribe(
        (response) => {
          //console.log(br)
         if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
          this.GetSainikDetailsFromRegistration(this.s.SR_ServiceNo); 
         }
         else{
          br.reset();
          br.resetForm();
         }
          //f.form.markAsPristine();
          // f.form.markAsUntouched();
          this.formInvalid = false;
          this.fingerprintimageUrl = "assets/images/image-default.png";
          swal('Success!', 'Sainik details saved successfully.', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          // window.location.href='http://sainik.esdinfra.com/index.html#/';
        }, (error) => {
          //console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
          // if(error.status == 401)
          // swal('Warning!', 'Not authorized to access this page.', 'warning');
           this.handleError.ErrorHandler(error);
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }

  UpdateBasicRegistration(sainikId,br: NgForm) {
    
    if (br.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      br.value.SR_Pincode=this.s.SR_Pincode;
       br.value.SR_PA_Pincode=this.s.SR_PA_Pincode;
      br.value.SR_FingerPrint = this.getFingerPrintImage();
      br.value.FingerPrintImagePath=this.s.FingerPrintImagePath;
      br.value.IdCardCode = this.s.IdCardCode;
      br.value.SainikDependents = this.FamilyDetails;

      this.data = this.service.updateBasicRegistration(sainikId,br.value);
      this.data.subscribe(
        (response) => {
          //console.log(br)
          if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
            this.GetSainikDetailsFromRegistration(this.s.SR_ServiceNo);
          }
          else{
           br.reset();
           br.resetForm();
          }
          //f.form.markAsPristine();
          // f.form.markAsUntouched();
          this.formInvalid = false;
          this.fingerprintimageUrl = "assets/images/image-default.png";
          swal('Success!', 'Sainik details updated successfully.', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          // window.location.href='http://sainik.esdinfra.com/index.html#/';
        }, (error) => {
          //console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
          this.handleError.ErrorHandler(error);
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;      
    }
  }

 
  ClearSRDOD(){
    if(this.s.SR_Alive=='YS'){
      this.s.SR_DOD='';
      this.FamilyDetails=[];
      this.fd={};
    }
  }
  
  GetRankBasedOnHonaryRank(value){
    
    //if(this.s.SR_HonoraryRank=='YS'){      
    if (value==1 || value==2)
    {

      this.s.SR_HonoraryRank="NO";
    }
    else if (value==3)
    {
      this.s.SR_HonoraryRank='YS'      
    }
      for(var j=0;j<this.Ranks.length;j++){
        this.rankobj[j]=this.Ranks[j];
      }


  // this.rankobj;
      for(var i=0;i<this.rankobj.length;i++){
        if(this.s.SR_HonoraryRank=='YS'){
          if(this.rankobj[i].Rank_Id==2 && 1)
          //this.rankobj.pop();
          this.rankobj.splice(i,1);
          this.rankobj.splice(i,2);
      }
      else if(this.s.SR_HonoraryRank=='NO'){
        if(this.rankobj[i].Rank_Id==3)
        this.rankobj.splice(i,3);
      }      
      //this.s.SR_Rank=3;
    }
    
    this.GetAllRankLevels(this.s.SR_ServiceType,this.s.SR_Category);
    // else  if(this.s.SR_HonoraryRank=='NO'){
    //   this.s.SR_Rank!=3;
    //   this.GetAllRankLevels(this.s.SR_ServiceType,this.s.SR_Rank);
    // } 
  }
  //Drop Downs
  GetAllRanks() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllRanks();
    this.data.subscribe(
      (response) => {
        this.Ranks = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        //console.log(error);
      });
  }

//for Ranklevel dropdown
  GetAllRankLevels(servicetypeid:any,rankId:any) {
    document.getElementById('loader-spinner').style.display = "block";
    
    /*if (rankId==3)
    {
      //getting other ranks if JCO is selected.
      rankId=2;      
    }*/
    this.data = this.service.getRankLevels(servicetypeid,rankId,this.s.SR_HonoraryRank);
    this.data.subscribe(
      (response) => {
        this.Ranklevels = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        //console.log(error);
      });
  }

  GetAllCorps() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllCorps();
    this.data.subscribe(
      (response) => {
        this.Corps = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllQualifications() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllQualification();
    this.data.subscribe(
      (response) => {
        this.Qualifications = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllCivilTypes() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllCivilTypes();
    this.data.subscribe(
      (response) => {
        this.CivilTypes = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllEquivalentTypes() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllEquivalentTypes();
    this.data.subscribe(
      (response) => {
        this.EquivalentTypes = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllServiceTypes() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllServiceTypes();
    this.data.subscribe(
      (response) => {
        this.ServiceTypes = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllServiceCategories() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllServiceCategories();
    this.data.subscribe(
      (response) => {
        this.ServiceCategories = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllRelegions() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllRelegions();
    this.data.subscribe(
      (response) => {
        this.Relegions = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllCaste() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllCaste();
    this.data.subscribe(
      (response) => {
        this.Castes = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllRelations() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllRelations();
    this.data.subscribe(
      (response) => {
        this.Relations = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllOccupationTypes() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllOccupationTypes();
    this.data.subscribe(
      (response) => {
        this.OccupationTypes = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetRecordOfficeDetailsForBasicRegistration(SR_Station_Id_FK:any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getRecordOfficeDetailsForBasicRegistration(SR_Station_Id_FK);
    this.data.subscribe(
      (response) => {
        this.recordofficedetails = response;

        this.s.SR_OA_Pincode=this.recordofficedetails[0].Station_Pincode;
        // this.s.SR_OA_Pincode=response.Station_Pincode;
        // this.s.Station_Email=response.Station_Email;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  
  GetSainikBasicDetails(SR_ServiceNo: any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getSainikBasicDetailsForBasicRegistration(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.s.SR_HonoraryRank='YS'
        this.s.SR_Veteran='YS'
        this.s.SR_Alive='YS'
        if (response != null) {
          this.s = response;
          if (this.s.SR_DOB != null)
            this.s.SR_DOB = ((this.s.SR_DOB).split('T'))[0];
          if (this.s.SR_DOC != null)
            this.s.SR_DOC = ((this.s.SR_DOC).split('T'))[0];
          if (this.s.SR_EnrollmentDate != null)
            this.s.SR_EnrollmentDate = ((this.s.SR_EnrollmentDate).split('T'))[0];
          if (this.s.SR_DOD != null)
            this.s.SR_DOD = ((this.s.SR_DOD).split('T'))[0];
          if (this.s.SR_DischargeDate != null)
            this.s.SR_DischargeDate = ((this.s.SR_DischargeDate).split('T'))[0];
          this.s.SR_ServiceType = this.s.ServiceTypes.SER_Id;
          this.s.SR_Category = this.s.ServiceCategories.CA_Id;
          this.s.SR_Rank = this.s.Ranks.Rank_Id;
          
          this.GetAllRankLevels(this.s.ServiceTypes.SER_Id,this.s.SR_Category);
          this.s.SR_RankLevel = this.s.SR_RankLevel;//added for ranklevel dropdown
         // this.s.SR_RankLevel = this.s.RankLevels.RL_Id;
          this.s.SR_Qualification = this.s.Qualifications.Q_Id;
          //this.s.SR_Corps = this.s.Corps.Corps_Id;
          //this.s.SR_CivilType = this.s.CivilTypes.Civil_Type_Id;
          this.s.SR_CivilType = this.s.SR_CivilType;
          this.s.SR_EquivalentType = this.s.EquivalentTypes.Equivalent_Type_Id;
          this.s.SR_Relegion = this.s.Relegions.Relegion_Id;
          this.s.SR_Caste = this.s.SR_Caste;   
          this.s.SR_OccupationType = this.s.OccupationTypes.OCT_Id;
          if(this.s.SR_OA_Pincode==0)
          this.s.SR_OA_Pincode="";
          // this.GetStates();
         //D this.s.SR_OA_State = response.SR_OA_State;
          //this.s.SR_OA_District = response.SR_OA_District;
         // this.s.SR_State = response.SR_State
         // this.s.SR_District=this.s.Districts.DI_Id;
         
          this.mode = "update";
          this.GetStates();
          this.GetOADistricts(response.SR_OA_State);
          this.GetDistricts(response.SR_State);
          this.GetPADistricts(response.SR_PA_State);
          //this.GetTaluks(response.SR_District);
          //this.GetPATaluks(response.SR_PA_District);
          //this.GetVillages(response.SR_Mandal);
          //this.GetPAVillages(response.SR_PA_Mandal);
          //this.GetPincode(response.SR_Village);
         // this.GetPAPincode(response.SR_PA_Village);
          this.fingerprintimageUrl=response.SR_FingerPrint;
          this.s.SR_FingerPrint=response.SR_FingerPrint;
          this.s.FingerPrintImagePath=response.FingerPrintImagePath;

          if(response.SR_Pincode==0)
          this.s.SR_Pincode="";
         // document.getElementById('SR_FingerPrint').nodeValue=response.SR_Id+'.jpeg';
          
        }

    
        //Dependents details
        if (response.SainikDependents.length != 0) {
          this.mode = "update";
          this.dependentsview="viewdependent";
        this.fd = {};
        this.fd = response.SainikDependents[0];
        this.fd.j=0;
        this.fd.relationid = this.GetRelationId(this.fd.Relations.Relation_Name);
        this.fd.qualificationid = this.GetQualifactionId(this.fd.SD_Qualification)
        this.fd['SD_DOB'] = ((response.SainikDependents[0].SD_DOB).split('T'))[0];
      }

      if(response.SR_Alive=='Yes')
      {
        this.s.SR_Alive='YS'
      }

        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400){
          if(this.RoleName=="Super Admin"){
            swal('Warning!', 'Sainik does not exist, Please fill the details', 'warning');
          }
          else{
          swal('Warning!', 'Sainik does not belong to this district or Sainik does not exist', 'warning');
           }
          }
        // swal('Warning!', 'Sainik does not exist.', 'warning');
    //swal('Warning!', 'Sainik does not belong to this district or Sainik does not exist .', 'warning');
        // else if(error.status == 401)
        // swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }

 
  GetStates() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getStates();
    this.data.subscribe(
      (response) => {
        this.States = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetOADistricts(stateId) {
    if (stateId != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.getDistricts(stateId);
      this.data.subscribe(
        (response) => {
          this.OADistricts = response;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          //console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
    else {
      this.s.SR_OA_District = undefined;
    }
  }

  GetDistricts(stateId) {
    if (stateId != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.getDistricts(stateId);
      this.data.subscribe(
        (response) => {
          this.Districts = response;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          //console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
    else {
      this.s.SR_District = undefined;
    }
  }

  GetPADistricts(stateId) {    
    if (stateId != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.getDistricts(stateId);
      this.data.subscribe(
        (response) => {
          this.PADistricts = response;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          //console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
    else {
      this.s.SR_PA_District = undefined;      
    }
  }

  // GetOATaluks(districtId) {
  //   if (districtId != undefined) {
  //     document.getElementById('loader-spinner').style.display = "block";
  //     this.data = this.service.getTaluks(districtId);
  //     this.data.subscribe(
  //       (response) => {
  //         this.OATaluks = response;
  //         document.getElementById('loader-spinner').style.display = "none";
  //       }, (error) => {
  //         console.log(error);
  //         document.getElementById('loader-spinner').style.display = "none";
  //       });
  //   }
  //   else {
  //     this.s.SR_OA_District = undefined;
  //     this.s.SR_OA_Mandal = undefined;
  //   }
  // }

  /*GetTaluks(districtId) {
    if (districtId != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.getTaluks(districtId);
      this.data.subscribe(
        (response) => {
          this.Taluks = response;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          //console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
    else {
      this.s.SR_District = undefined;
      this.s.SR_Mandal = undefined;
    }
  }*/

  /*GetPATaluks(districtId) {
    if (districtId != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.getTaluks(districtId);
      this.data.subscribe(
        (response) => {
          this.PATaluks = response;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          //console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
    else {
      this.s.SR_PA_District = undefined;
      this.s.SR_PA_Mandal = undefined;
    }
  }*/

  // GetOAVillages(talukId) {
  //   if (talukId != undefined) {
  //     document.getElementById('loader-spinner').style.display = "block";
  //     this.data = this.service.getVillages(talukId);
  //     this.data.subscribe(
  //       (response) => {
  //         this.OAVillages = response;
  //         document.getElementById('loader-spinner').style.display = "none";
  //       }, (error) => {
  //         console.log(error);
  //         document.getElementById('loader-spinner').style.display = "none";
  //       });
  //   }
  //   else {
  //     this.s.SR_OA_District = undefined;
  //     this.s.SR_OA_Mandal = undefined;
  //     this.s.SR_Village = undefined;
  //   }
  // }

  /*GetVillages(talukId) {
    if (talukId != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.getVillages(talukId);
      this.data.subscribe(
        (response) => {
          this.Villages = response;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
    else {
      this.s.SR_District = undefined;
      this.s.SR_Mandal = undefined;
      this.s.SR_Village = undefined;
    }
  }*/

  /*GetPAVillages(talukId) {
    if (talukId != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.getVillages(talukId);
      this.data.subscribe(
        (response) => {
          this.PAVillages = response;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
    else {
      this.s.SR_PA_District = undefined;
      this.s.SR_PA_Mandal = undefined;
      this.s.SR_PA_Village = undefined;
    }
  }*/
//Getting Pincode based villageid
 /* GetPincode(villageId: number) {
    for (let i = 0; i <= this.Villages.length; i++) {
      if (villageId == this.Villages[i].VI_Id)
         this.s.SR_Pincode = this.Villages[i].VI_PinCode;
   }
  }}*/

 /* GetPAPincode(villageId: number) {
    
    for (let i = 0; i <= this.PAVillages.length; i++) {
      if (villageId == this.PAVillages[i].VI_Id)
        this.s.SR_PA_Pincode = this.PAVillages[i].VI_PinCode;
    }
  }*/



//For Adding Dependents


FamilyDetails = [];
  SD_Name_errormessage = "";
  SD_DOB_errormessage = "";
  SD_Relation_errormessage = "";
  SR_Photo_errormessage = "";


  AddFamily(fd) {
    if (this.checkAllFamilyValidation(fd)) {
      let temp = {
        j:fd.j,
        SD_Id: fd.SD_Id,
        SD_Name: fd.SD_Name,
        SD_Gender: fd.SD_Gender,
        SD_DOB: fd.SD_DOB,
        relationName: this.GetAllRelationName(fd.relationid),
        SD_Qualification: this.GetAllQualificationName(fd.qualificationid),
        SD_Relation_Id_FK: fd.relationid,
        SD_Q_Id_FK: fd.qualificationid,
        SD_IdCardNo: fd.SD_IdCardNo,
        SD_AdharCard: fd.SD_AdharCard,
        SD_IsDisabled: fd.SD_IsDisabled,
        SD_Email: fd.SD_Email,
        SD_Mobile: fd.SD_Mobile,
        SD_OtherInfo: fd.SD_OtherInfo,
      }

        for (let i = 0; i < this.FamilyDetails.length; i++) {                   
             let len=this.FamilyDetails.length-1;
               if(i==fd.j && fd.j!=undefined)
               {
                 this.FamilyDetails[i].SD_Id=fd.SD_Id;
                 this.FamilyDetails[i].SD_Name=fd.SD_Name;
                 this.FamilyDetails[i].SD_Gender=fd.SD_Gender;
                 this.FamilyDetails[i].SD_DOB=fd.SD_DOB;
                 this.FamilyDetails[i].relationName=this.GetAllRelationName(fd.relationid);
                 this.FamilyDetails[i].SD_Qualification=this.GetAllQualificationName(fd.qualificationid);
                 this.FamilyDetails[i].SD_Relation_Id_FK=fd.relationid;
                this.FamilyDetails[i].SD_Q_Id_FK=fd.qualificationid;
                 this.FamilyDetails[i].SD_IdCardNo=fd.SD_IdCardNo;
                 this.FamilyDetails[i].SD_AdharCard=fd.SD_AdharCard;
                 this.FamilyDetails[i].SD_Name=fd.SD_Name;
                 this.FamilyDetails[i].SD_IsDisabled=fd.SD_IsDisabled;
                 this.FamilyDetails[i].SD_Email=fd.SD_Email;
                 this.FamilyDetails[i].SD_Mobile=fd.SD_Mobile;
                 this.FamilyDetails[i].SD_OtherInfo=fd.SD_OtherInfo;
               } 
               else if(fd.j==undefined && len==i){
                fd.SD_Relation_Id_FK= fd.relationid;
                fd.SD_Q_Id_FK=fd.qualificationid;
                fd.relationName= this.GetAllRelationName(fd.relationid);
                fd.SD_Qualification=this.GetAllQualificationName(fd.qualificationid);
              this.FamilyDetails.push(fd);
              break;
              }
       }
      if(this.FamilyDetails.length==0|| this.FamilyDetails.length==undefined){
        fd.SD_Relation_Id_FK= fd.relationid;
        fd.SD_Q_Id_FK=fd.qualificationid;
        fd.relationName= this.GetAllRelationName(fd.relationid);
        fd.SD_Qualification=this.GetAllQualificationName(fd.qualificationid);
        this.FamilyDetails.push(fd);
         }
      this.closeModalDialog();
     // this.fd = {};
      this.SD_Relation_errormessage = "";
      console.log(temp);
    }
    else
    {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }

  closeModalDialog() {
    $("#detailspopup").modal('hide');
  }


  GetAllRelationName(relationId) {
    for (let i = 0; i < this.Relations.length; i++) {
      if (this.Relations[i].Relation_Id == relationId) {
        let relationName = this.Relations[i].Relation_Name;
        return relationName;
      }
    }
  }

  GetAllQualificationName(qualificationId) {
    for (let i = 0; i < this.Qualifications.length; i++) {
      if (this.Qualifications[i].Q_Id == qualificationId) {
        let qualificationName = this.Qualifications[i].Q_Name;
        return qualificationName;
      }
    }
  }

  keyPress(event: any) {    
    const pattern =/[A-Za-z]/;
    let inputChar = String.fromCharCode(event.charCode);
    var uname = new String(event.target.value)
    if (!pattern.test(inputChar) && uname.trim().length==0)
    {
      event.preventDefault();
    }
 }


 GetRelationId(relationName) {
  for (let i = 0; i < this.Relations.length; i++) {
    if (this.Relations[i].Relation_Name == relationName) {
      let relationid = this.Relations[i].Relation_Id;
      return relationid;
    }
  }
}

GetQualifactionId(qualifationname) {
  for (let i = 0; i < this.Qualifications.length; i++) {
    if (this.Qualifications[i].Q_Name == qualifationname) {
      let qualificationid = this.Qualifications[i].Q_Id;
      return qualificationid;
    }
  }
}

//Stations Drop Downs
GetAllStationsOfRecordOfficeAddress() {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllStationsOfRecordOfficeAddress();
  this.data.subscribe(
    (response) => {
      this.Stations = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      //console.log(error);
    });
}

CheckDOB(DOB)
{
  // 
   let ageofcust;
  // this.DOBempty=false;
  if(DOB.length>10)
   swal('Date','Enter correct date')
  else if (DOB) {
  //convert date again to type Date
  const bdate = new Date(DOB);
  const timeDiff = Math.abs(Date.now() - bdate.getTime() );
  //this.m.Daughter_Age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
  ageofcust= Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
  if(ageofcust<18)
  {
    swal('Warning','Sainik age must be greater than 18 years old',"warning");
    this.s.SR_DOB='';
  }
}

}






  
  //*********validation********** */
  CheckRequired(value) {
    if (typeof (value) != undefined && value != '' && value != null)
      return true;
    else
      return false;
  }

  checkAllFamilyValidation(fd: any) {
    let result1 = this.CheckFamilyName(fd.SD_Name);
    let result2 = this.CheckFamilyDOB(fd.SD_DOB);
    let result3 = this.CheckFamilyRelation(fd.relationid);
    let result4 = this.CheckFamilyQualification(fd.qualificationid);
    let result5 = this.CheckFamilyGender(fd.SD_Gender);

    if (result1 && result2 && result3 && result4 && result5)
      return true;
    else
      return false;
  }

  CheckFamilyName(name) {
    if (this.CheckRequired(name)) {
      this.SD_Name_errormessage = "";
      return true;
    }
    else {
      this.SD_Name_errormessage = "Please enter name";
      return false;
    }
  }

  CheckFamilyDOB(dob) {
    if (this.CheckRequired(dob)) {
      this.SD_DOB_errormessage = "";
      return true;
    }
    else {
      this.SD_DOB_errormessage = "Please enter DOB";
      return false;
    }
  }

  CheckFamilyRelation(relation) {
    if (this.CheckRequired(relation)) {
      this.SD_Relation_errormessage = "";
      return true;
    }
    else {
      this.SD_Relation_errormessage = "Please select relation";
      return false;
    }
  }

  CheckFamilyQualification(qualification) {
    if (this.CheckRequired(qualification)) {
      this.SD_Qualifictaion_errormessage = "";
      return true;
    }
    else {
      this.SD_Qualifictaion_errormessage = "Please select qualification";
      return false;
    }
  }

  CheckFamilyGender(gender) {
    if (this.CheckRequired(gender)) {
      this.SD_Gender_errormessage = "";
      return true;
    }
    else {
      this.SD_Gender_errormessage = "Please select one";
      return false;
    }
  }

  CheckMobileval(mobno)
  {
    
    if(mobno.length<10)
    {
      swal('Warning','Mobile No. should not be less than 10 digits',"warning");
    }

    }




}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/basic-registration/basic-registration.component.ts